<script setup lang="ts">
withDefaults(
  defineProps<{
    as?: string
    columns?: 1 | 2 | 3 | 4
    gap?: '1' | '2' | '3' | '4' | '6' | '8'
    minWidth?: string
  }>(),
  { minWidth: undefined, as: 'div', columns: 2, gap: '4' },
)
</script>
<template>
  <component
    :is="as"
    class="ui-grid"
    :class="`ui-gap--${gap}`"
    :style="{
      '--ui-columns': columns,
      gridTemplateColumns: minWidth
        ? `repeat(auto-fit, minmax(min(100%, ${minWidth}), 1fr))`
        : undefined,
    }"
    ><slot
  /></component>
</template>
